import { render, staticRenderFns } from "./flowShipmentAct.vue?vue&type=template&id=848138ce&scoped=true&"
import script from "./flowShipmentAct.vue?vue&type=script&lang=js&"
export * from "./flowShipmentAct.vue?vue&type=script&lang=js&"
import style0 from "./flowShipmentAct.vue?vue&type=style&index=0&id=848138ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848138ce",
  null
  
)

export default component.exports